export const diagnosticColors: string[] = ['#E0E0E0', '#40BF5F', '#FDC365', '#F07575', '#8E85EF'];
